import { useImpersonation } from '@app/core/auth/impersonation';
import debugFn from 'debug';
import { usePostHog } from 'posthog-js/react';
import { useEffect, useState } from 'react';
import { useAuth } from '../../auth/authentication/hooks/useAuth';

const debug = debugFn('usePostHogIdentify');

export function usePostHogIdentify() {
  const { user, client } = useAuth();
  const { impersonatedUser } = useImpersonation();
  const posthog = usePostHog();

  const [posthogReady, setPosthogReady] = useState(false);

  useEffect(() => {
    debug('identifying user', user.email);

    posthog?.identify(user.email, {
      id: user.id,
      email: user.email,
      client: client?.slug,
      role: user.role,
      impersonatedUser: impersonatedUser?.email,
    });

    setPosthogReady(true);
  }, [user, posthog, impersonatedUser]);

  return posthogReady;
}
